var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{class:{
    center: !_vm.center,
  }},[_c('md-progress-spinner',{attrs:{"md-diameter":_vm.diameter,"md-stroke":_vm.stroke,"md-mode":"indeterminate"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }